export interface Brand {
  id: string | number;
  sourceBrandId?: string;
  name?: string;
  englishName?: string;
  aliases?: string[] | string | null;
  status?: number;
  remark?: string;
  createdAt?: string;
  updatedAt?: string;
  created_at?: string;
  updated_at?: string;
}

export const BrandLabels = {
  sourceBrandId: '来源品牌ID',
  name: '品牌名称',
  englishName: '英文名',
  aliases: '别名',
  status: '状态',
  remark: '备注',
};
